module.exports = __webpack_public_path__ + "img/zx_mb.9a141050.jpg";